<template>
    <div class="realtive z-30">
        <!-- Sidebar -->
        <div
            id="sidebar"
            class="flex flex-col absolute z-30 left-0 top-0 transform h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 flex-shrink-0 bg-navy-800 p-4 transition-all duration-200 ease-in-out"
        >
            <!-- Sidebar header -->
            <div class="flex justify-between items-center mb-10 pr-3 sm:px-2">
                <!-- Close button -->
                <button
                    class="lg:hidden text-gray-500 hover:text-gray-400"
                    @click.stop="isSidebarOpen = !isSidebarOpen"
                    aria-controls="sidebar"
                    :aria-expanded="isSidebarOpen"
                    v-if="isSidebarOpen"
                >
                    <span class="sr-only">Close sidebar</span>
                    <svg
                        class="w-6 h-6 fill-current"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z"
                        />
                    </svg>
                </button>
                <!-- Logo -->
                <a class="block text-center w-full" href="/dashboard">
                    <img
                        src="/images/white-logo.svg"
                        class="mx-auto"
                        style="width: 110px; height: auto"
                        alt="My10X"
                    />
                </a>
            </div>

            <!-- Links -->
            <div class="space-y-8">
                <!-- Pages group -->
                <div>
                    <ul class="mt-3">
                        <!-- Dashboard -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-600': page === 'dashboard' }"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/dashboard"
                            >
                                <div class="flex items-center">
                                    <Icon
                                        icon="dashboard"
                                        class="w-6 h-6"
                                        :class="{
                                            'text-orange-600':
                                                page === 'dashboard',
                                        }"
                                    />
                                    <span
                                        class="text-sm font-medium ml-3 duration-200"
                                    >
                                        Dashboard
                                    </span>
                                </div>
                            </a>
                        </li>
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-700': page === 'wallet' }"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/wallet"
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <Icon
                                            icon="wallet"
                                            class="w-6 h-6"
                                            :class="{
                                                'text-orange-600':
                                                    page === 'wallet',
                                            }"
                                        />
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            My Wallet
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </li>

                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-700': page === 'mypoints' }"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/mypoints"
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <Icon
                                            icon="points"
                                            class="w-6 h-6"
                                            :class="{
                                                'text-orange-600':
                                                    page === 'mypoints',
                                            }"
                                        />

                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            My Points
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-700': page === 'mynextcard' }"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/mynextcard"
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <Icon
                                            icon="credit-card"
                                            class="w-6 h-6"
                                            :class="{
                                                'text-orange-600':
                                                    page === 'mynextcard',
                                            }"
                                        />
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            My Next Card
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-700': page === 'creditscore' }"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/credit-score"
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <Icon
                                            icon="credit-score"
                                            class="w-6 h-6"
                                            :class="{
                                                'text-orange-600':
                                                    page === 'creditscore',
                                            }"
                                        />
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            My Credit Score
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-700': page === 'courses' }"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/course"
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <Icon
                                            icon="courses"
                                            class="w-6 h-6"
                                            :class="{
                                                'text-orange-600':
                                                    page === 'courses',
                                            }"
                                        />
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            10x Course
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            :class="{ 'bg-navy-700': page === 'travelplus' }"
                            v-if="userSettings.features.travelplus"
                        >
                            <a
                                class="block text-gray-200 truncate transition duration-150"
                                href="/10xtravel-plus"
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <Icon
                                            icon="star"
                                            class="w-6 h-6"
                                            :class="{
                                                'text-orange-600':
                                                    page === 'travelplus',
                                            }"
                                        />
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            10xTravel+
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>

                    <!-- ** TOOLS ** -->
                    <div class="mt-8">
                        <h3
                            class="text-xs uppercase text-gray-500 font-semibold pl-3"
                        >
                            <span class="xl:block">Tools</span>
                        </h3>
                        <ul class="mt-3">
                            <li
                                class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            >
                                <a
                                    class="block text-gray-200 truncate transition duration-150"
                                    href="/companionpass"
                                >
                                    <div
                                        class="flex items-center justify-between"
                                    >
                                        <div class="flex items-center">
                                            <Icon
                                                icon="ticket"
                                                class="w-6 h-6"
                                                :class="{
                                                    'text-orange-600':
                                                        page ===
                                                        'tools.companionpass',
                                                }"
                                            />
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Companion Pass
                                            </span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                                v-if="userSettings.features.tools_hotels"
                            >
                                <a
                                    class="sidebar-expander-link block text-gray-200 transition duration-150"
                                    :class="
                                        nav.hotels.open && 'hover:text-gray-200'
                                    "
                                    href="/hotels"
                                    @click.prevent="
                                        nav.hotels.open = !nav.hotels.open
                                    "
                                >
                                    <div
                                        class="flex items-center justify-between"
                                    >
                                        <div class="flex items-center">
                                            <Icon
                                                icon="hotel"
                                                class="w-6 h-6"
                                                :class="{
                                                    'text-orange-600':
                                                        page === 'tools.hotels',
                                                }"
                                            />
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Hotel Availability
                                            </span>
                                        </div>
                                        <!-- Icon -->
                                        <div
                                            class="flex flex-shrink-0 ml-2 duration-200"
                                        >
                                            <svg
                                                class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                                :class="{
                                                    'transform rotate-180':
                                                        nav.hotels.open,
                                                }"
                                                viewBox="0 0 12 12"
                                            >
                                                <path
                                                    d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </a>
                                <div
                                    class="pl-9 mt-1"
                                    :class="{
                                        hidden: !nav.hotels.open,
                                    }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate mb-1"
                                            href="/hotels/"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Hotel Availability
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate mb-1"
                                            href="/hotels/favorites"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Favorite Hotels
                                            </span>
                                        </a>
                                    </li>
                                </div>
                            </li>
                            <li
                                v-if="userSettings.features.tools_hotels"
                                class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            >
                                <a
                                    class="block text-gray-200 truncate transition duration-150"
                                    href="/alerts/"
                                >
                                    <div
                                        class="flex items-center justify-between"
                                    >
                                        <div class="flex items-center">
                                            <i
                                                class="fa-regular fa-bell text-xl align-middle fa-fw"
                                                :class="{
                                                    'text-orange':
                                                        page === 'alerts',
                                                }"
                                            ></i>
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Alerts
                                            </span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <!-- START LOUNGE FINDER -->
                            <li
                                class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            >
                                <a
                                    class="sidebar-expander-link block text-gray-200 transition duration-150"
                                    :class="{
                                        'hover:text-gray-200':
                                            nav.tools.lounges.open,
                                    }"
                                    href="/lounges"
                                    @click.prevent="
                                        nav.tools.lounges.open =
                                            !nav.tools.lounges.open
                                    "
                                >
                                    <div
                                        class="flex items-center justify-between"
                                    >
                                        <div class="flex items-center">
                                            <Icon
                                                icon="lounge"
                                                class="w-6 h-6"
                                                :pathClass="
                                                    page === 'lounges'
                                                        ? 'fill-orange-600'
                                                        : 'fill-white'
                                                "
                                            />
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Lounge Finder
                                            </span>
                                        </div>
                                        <!-- Icon -->
                                        <div
                                            class="flex flex-shrink-0 ml-2 duration-200"
                                        >
                                            <svg
                                                class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                                :class="{
                                                    'transform rotate-180':
                                                        nav.tools.lounges.open,
                                                }"
                                                viewBox="0 0 12 12"
                                            >
                                                <path
                                                    d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </a>
                                <div
                                    class="pl-9 mt-1"
                                    :class="{ hidden: !nav.tools.lounges.open }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate mb-1"
                                            href="/lounges/"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Lounge Search
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate mb-1"
                                            href="/lounges/favorites"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Favorite Lounges
                                            </span>
                                        </a>
                                    </li>
                                </div>
                            </li>
                            <!-- END LOUNGE FINDER -->
                            <li
                                class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            >
                                <a
                                    class="block text-gray-200 truncate transition duration-150"
                                    href="/trips"
                                >
                                    <div
                                        class="flex items-center justify-between"
                                    >
                                        <div class="flex items-center">
                                            <Icon
                                                icon="redemption-tracker"
                                                class="w-6 h-6"
                                                :class="{
                                                    'text-orange-600':
                                                        page === 'redemptions',
                                                }"
                                            />
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Redemption Tracker
                                            </span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!-- ** END TOOLS ** -->
                </div>
                <!-- More group -->
                <div v-if="userSettings.is_admin || userSettings.is_staff">
                    <h3
                        class="text-xs uppercase text-gray-500 font-semibold pl-3"
                    >
                        <span class="xl:block">Admin</span>
                    </h3>
                    <ul class="mt-3">
                        <!-- ADMIN -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            v-if="userSettings.is_admin"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 hover:text-white transition duration-150"
                                href="/admin/"
                                @click.prevent="
                                    nav.admin.admin.open = !nav.admin.admin.open
                                "
                                :class="
                                    nav.admin.admin.open &&
                                    'hover:text-gray-200'
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fa-solid fa-gear text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Admin
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.admin.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div class="lg:sidebar-expanded:block 2xl:block">
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{ hidden: !nav.admin.admin.open }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Admin Dashboard
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- CARDS -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 hover:text-white transition duration-150"
                                :class="
                                    nav.admin.cards.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/cards"
                                @click.prevent="
                                    nav.admin.cards.open = !nav.admin.cards.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fas fa-credit-card text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Cards
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.cards.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{ hidden: !nav.admin.cards.open }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/cards"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                All Cards
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/cards/create"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Create Card
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/cards/sort"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Card Rankings
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/card-matches"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Card Matches
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- PROGRAMS -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.programs.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/programs"
                                @click.prevent="
                                    nav.admin.programs.open =
                                        !nav.admin.programs.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fas fa-cabinet-filing text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Programs
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.programs.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{
                                        hidden: !nav.admin.programs.open,
                                    }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/programs"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                All Programs
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/programs/create"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Create Program
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/airlines"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Airlines
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/transfer-partners"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Transfer Partners
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/transfer-partner-matches"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Transfer Partner Matches
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/transfer-partner-bonuses"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Transfer Partner Bonuses
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- COURSES -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.courses.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/courses"
                                @click.prevent="
                                    nav.admin.courses.open =
                                        !nav.admin.courses.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fa-solid fa-school text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Courses
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.courses.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{ hidden: !nav.admin.courses.open }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 hover:text-gray-200 transition duration-150 truncate"
                                            href="/admin/courses"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                All Courses
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 hover:text-gray-200 transition duration-150 truncate"
                                            href="/admin/courses/create"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Create New Course
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- ISSUING BANKS -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.banks.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/banks"
                                @click.prevent="
                                    nav.admin.banks.open = !nav.admin.banks.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fas fa-building-columns text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Issuing Banks
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.banks.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{ hidden: !nav.admin.banks.open }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 hover:text-gray-200 transition duration-150 truncate"
                                            href="/admin/banks"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                All Issuing Banks
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 hover:text-gray-200 transition duration-150 truncate"
                                            href="/admin/banks/create"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Create Issuing Bank
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- USERS -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.users.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/users"
                                @click.prevent="
                                    nav.admin.users.open = !nav.admin.users.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fas fa-users text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Users
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.users.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{ hidden: !nav.admin.users.open }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/users"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                All Users
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/users/create"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Create User
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <!-- UNRESOLVED ACCOUNTS -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.unresolved.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/resolve-card-matches"
                                @click.prevent="
                                    nav.admin.unresolved.open =
                                        !nav.admin.unresolved.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fa-light fa-radar text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Unresolved Cards
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.unresolved.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{
                                        hidden: !nav.admin.unresolved.open,
                                    }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/resolve-card-matches"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Unresolved Accounts
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- SETTINGS -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            v-if="userSettings.is_admin"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.settings.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/settings"
                                @click.prevent="
                                    nav.admin.settings.open =
                                        !nav.admin.settings.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fa-light fa-cog text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Settings
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.settings.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{
                                        hidden: !nav.admin.settings.open,
                                    }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/settings"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Settings
                                            </span>
                                        </a>
                                    </li>

                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/settings/tools/"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Tools
                                            </span>
                                        </a>
                                    </li>
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 transition duration-150 truncate"
                                            href="/admin/changelog"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                Changelog
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!-- MAIL PREVIEW -->
                        <li
                            class="px-3 py-2 rounded-sm mb-2 last:mb-0 hover:bg-navy-500 transition-all"
                            v-if="userSettings.is_admin"
                        >
                            <a
                                class="sidebar-expander-link block text-gray-200 transition duration-150"
                                :class="
                                    nav.admin.mailpreview.open &&
                                    'hover:text-gray-200'
                                "
                                href="/admin/mail-preview"
                                @click.prevent="
                                    nav.admin.mailpreview.open =
                                        !nav.admin.mailpreview.open
                                "
                            >
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i
                                            class="fa-light fa-envelope text-xl fa-fw"
                                        ></i>
                                        <span
                                            class="text-sm font-medium ml-3 duration-200"
                                        >
                                            Mail Preview
                                        </span>
                                    </div>
                                    <!-- Icon -->
                                    <div
                                        class="flex flex-shrink-0 ml-2 duration-200"
                                    >
                                        <svg
                                            class="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
                                            :class="{
                                                'transform rotate-180':
                                                    nav.admin.mailpreview.open,
                                            }"
                                            viewBox="0 0 12 12"
                                        >
                                            <path
                                                d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </a>
                            <div>
                                <ul
                                    class="pl-9 mt-1"
                                    :class="{
                                        hidden: !nav.admin.mailpreview.open,
                                    }"
                                >
                                    <li class="mb-1 last:mb-0">
                                        <a
                                            class="block text-gray-400 hover:text-gray-200 transition duration-150 truncate"
                                            href="/admin/mail-preview"
                                        >
                                            <span
                                                class="text-sm font-medium ml-3 duration-200"
                                            >
                                                All Mail Previews
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="mt-auto mb-10 py-1 text-left flex flex-col items-start">
                <div
                    class="mb-2 py-1 text-left flex items-center hover:bg-navy-500 transition-all w-full"
                    :class="{ 'bg-navy-500': page === 'support' }"
                >
                    <a
                        href="/support/"
                        class="flex items-center w-full text-gray-200 transition duration-150 text-sm font-medium ml-3"
                    >
                        <Icon
                            icon="support"
                            class="w-6 h-6"
                            :class="{
                                'text-orange-600': page === 'support',
                            }"
                        />
                        <span class="ml-3">Help & Support</span>
                    </a>
                </div>
                <div
                    class="mb-5 py-1 text-left flex items-center hover:bg-navy-500 transition-all w-full"
                    :class="{ 'bg-navy-500': page === 'faq' }"
                >
                    <a
                        href="/faq/"
                        class="flex items-center w-full text-gray-200 transition duration-150 text-sm font-medium ml-3"
                    >
                        <Icon
                            icon="faq"
                            class="w-6 h-6"
                            :class="{
                                'text-orange-600': page === 'faq',
                            }"
                        />
                        <span class="ml-3">FAQ</span>
                    </a>
                </div>
            </div>

            <!-- Expand / collapse button -->
            <div
                class="pt-3 hidden lg:inline-flex xl:hidden justify-end mt-auto"
            >
                <div class="px-3 py-2">
                    <button @click.stop="isSidebarOpen = !isSidebarOpen">
                        <span class="sr-only">Expand / collapse sidebar</span>
                        <svg
                            class="w-6 h-6 fill-current sidebar-expanded:rotate-180"
                            viewBox="0 0 24 24"
                        >
                            <path
                                class="text-gray-400"
                                d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z"
                            />
                            <path class="text-gray-600" d="M3 23H1V1h2z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useAppStore } from '@/store/app';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    props: {
        data: Object,
    },
    components: {
        Icon,
    },
    data: () => ({
        page: 'dashboard',
        nav: {
            dashboard: {
                index: {
                    title: 'Dashboard',
                    name: 'dashboard',
                    open: false,
                },
            },
            wallet: {
                index: {
                    title: 'Wallet',
                    name: 'wallet',
                    open: false,
                },
                accounts: {
                    title: 'Accounts',
                    name: 'accounts',
                    open: false,
                },
            },
            creditscore: {
                index: {
                    title: 'My Credit Score',
                    name: 'creditscore',
                    open: false,
                },
            },
            courses: {
                index: {
                    title: '10x Course',
                    name: 'courses',
                    open: false,
                },
            },
            redemptions: {
                index: {
                    title: 'Redemptions',
                    name: 'redemptions',
                    open: false,
                },
            },
            mypoints: {
                index: {
                    title: 'My Points',
                    name: 'mypoints',
                    open: false,
                },
            },
            mynextcard: {
                index: {
                    title: 'My Next Card',
                    name: 'mynextcard',
                    open: false,
                },
            },
            members: {
                index: {
                    title: 'Member Connections',
                    name: 'members',
                    open: false,
                },
            },
            faq: {
                index: {
                    title: 'Faq',
                    name: 'faq',
                    open: false,
                },
            },
            alerts: {
                title: 'Alerts',
                name: 'alerts',
                open: false,
            },
            hotels: {
                title: 'Hotels',
                name: 'hotels',
                open: false,
            },
            tools: {
                companionpass: {
                    title: 'Companion Pass',
                    name: 'companionpass',
                    open: false,
                },
                lounges: {
                    title: 'Lounge Finder',
                    name: 'lounges',
                    open: false,
                },
            },
            security: {
                index: {
                    title: 'Security',
                    name: 'security',
                    open: false,
                },
            },
            support: {
                index: {
                    title: 'Support',
                    name: 'support',
                    open: false,
                },
            },
            settings: {
                index: {
                    title: 'Settings',
                    name: 'settings',
                    open: false,
                },
                changelog: {
                    title: 'Changelog',
                    name: 'changelog',
                    open: false,
                },
            },
            admin: {
                admin: {
                    title: 'Admin',
                    name: 'admin.admin',
                    open: false,
                },
                cards: {
                    title: 'Cards',
                    name: 'admin.cards',
                    open: false,
                },
                courses: {
                    title: 'Courses',
                    name: 'admin.courses',
                    open: false,
                },
                TravelPlus: {
                    title: 'TravelPlus',
                    name: 'TravelPlus',
                    open: false,
                },
                programs: {
                    title: 'Programs',
                    name: 'admin.programs',
                    open: false,
                },
                banks: {
                    title: 'Issuing Banks',
                    name: 'admin.banks',
                    open: false,
                },
                users: {
                    title: 'Users',
                    name: 'admin.users',
                    open: false,
                },
                unresolved: {
                    title: 'Unresolved Accounts',
                    name: 'admin.unresolved',
                    open: false,
                },
                mailpreview: {
                    title: 'Mail Preview',
                    name: 'admin.mailpreview',
                    open: false,
                },
                settings: {
                    title: 'Settings',
                    name: 'admin.settings',
                    open: false,
                },
            },
            travelplus: {
                index: {
                    title: '10xTravel+',
                    name: 'travelplus',
                    open: false,
                },
            },
        },
    }),
    computed: {
        ...mapState(useAppStore, ['sidebarOpen', 'userSettings']),
        isSidebarOpen: {
            get() {
                return this.sidebarOpen;
            },
            set(value) {
                this.setSidebarOpen(value);
            },
        },
    },
    directives: {},
    methods: {
        ...mapActions(useAppStore, ['setSidebarOpen']),
        handlePage() {
            const $dataPageEl = document.querySelector('[data-page]');
            let thisPage;

            // First check if we're on the trip-swap page
            const currentPath = window.location.pathname;
            if (currentPath.includes('/trip-swap')) {
                this.page = 'tripswap';
                return;
            }

            if ($dataPageEl !== null) {
                const page = $dataPageEl.getAttribute('data-page');
                if (page !== 'tools') {
                    this.page = page;
                    thisPage = page.split('.').reduce((o, i) => o[i], this.nav);
                } else {
                    const urlPartsArray = this.getToolsPage();
                    if (urlPartsArray.includes('hotels')) {
                        this.page = 'tools.hotels';
                        thisPage = this.nav.tools.hotels;
                    } else if (urlPartsArray.includes('alerts')) {
                        this.page = 'tools.alerts';
                        thisPage = this.nav.tools.alerts;
                    } else if (urlPartsArray.includes('lounges')) {
                        this.page = 'lounges';
                        thisPage = this.nav.tools.lounges;
                    }
                }
                if (thisPage) {
                    thisPage.open = true;
                }
            }
        },
        getToolsPage() {
            const currentPath = window.location.pathname;
            const pathParts = currentPath.split('/');

            return pathParts;
        },
        resizedw() {
            this.winWidth = window.innerWidth;
            if (this.winWidth <= 1024) {
                this.isSidebarOpen = false;
            }
        },
        navigateToTravelPlus() {
            this.page = 'TravelPlus';
            this.$router.push('/10xTravelplus');
        },
    },

    created() {},
    mounted() {
        this.handlePage();
        this.winWidth = window.innerWidth;
        if (this.winWidth <= 1024) {
            this.isSidebarOpen = false;
        }

        let dbounce;
        window.onresize = () => {
            clearTimeout(dbounce);
            dbounce = setTimeout(this.resizedw, 100);
        };
    },
};
</script>
